var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMyPlan = function SvgMyPlan(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none",
    viewBox: "0 0 18 18"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    x: 1,
    y: 1,
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    rx: 2,
    vectorEffect: "non-scaling-stroke"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M7.92 3.95a.6.6 0 0 0-.6.6v2.77H4.55a.6.6 0 0 0-.6.6v2.59c0 .33.27.6.6.6h2.77v2.34c0 .33.26.6.6.6h2.59a.6.6 0 0 0 .6-.6v-2.34h2.34a.6.6 0 0 0 .6-.6V7.9a.6.6 0 0 0-.6-.6h-2.34V4.56a.6.6 0 0 0-.6-.6H7.9Z",
    clipRule: "evenodd"
  })));
};
export default SvgMyPlan;